var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-content"},[_c('vue-markdown',{attrs:{"source":_vm.source}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }